<script setup lang="ts">
const { getFormattedPrice, currencyCode } = usePrice();
const props = defineProps<{
  value: number | undefined;
}>();

  const getPrice = computed<string>(() => {
  const formattedPrice = getFormattedPrice(props.value);
  return `${currencyCode.value}` +` `+ `${formattedPrice.replace(',', '.').replace(currencyCode.value, '')}`;
});
</script>

<template>
  <span class="font-bold">
    <slot name="beforePrice" />
    <span>{{ getPrice }}</span>
    <slot name="afterPrice" />
  </span>
</template>
